<template>
    <div id="app">
        <app-header v-if="header_show"></app-header>
        <router-view v-on:header="header" v-on:footer="footer"/>
        <app-footer v-if="footer_show"></app-footer>
    </div>
</template>
<script>
    import AppHeader from '@/components/AppHeader.vue';
    import AppFooter from '@/components/AppFooter.vue';
    import '@/assets/css/public.css';

    export default {
        name: "app",
        data() {
            return {
                header_show: false,
                footer_show: false,
            }
        },
        components: {
            AppHeader, AppFooter
        },
        /*watch: {
            '$route'(to, from) {
                //let authorityPage = ["/", "/index", "/report", "/personal", "/401", "/404", "/500"];
                this.footer_show = !(authorityPage.findIndex((value, index, arr) => {
                    return value === to.path
                }) === -1);
            }
        },*/
        methods: {
            //是否显示头部
            header: function (bool) {
                this.header_show = bool;
            },
            //是否显示底部
            footer: function (bool) {
                this.footer_show = bool;
            }
        }
    }
</script>
<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        background-color: #F7F8FA;

        .fSize {
            font-size: 0.3rem !important;
        }

        .fontWE {
            font-weight: 700;
        }

        .colorR {
            color: red;
        }

        .textR {
            text-align: right;
        }

        .textC {
            text-align: center;
        }

        .font28 {
            font-size: 0.28rem;
        }

        .buttonFixed {
            position: fixed;
            bottom: 0;

            button {
                height: 0.8rem;
            }
        }
    }
</style>
